/*! instant.page v1.2.2 - (C) 2019 Alexandre Dieulot - https://instant.page/license */
let urlToPreload
let mouseoverTimer
let lastTouchTimestamp
const prefetcher=document.createElement('link')
const isSupported=prefetcher.relList&&prefetcher.relList.supports&&prefetcher.relList.supports('prefetch')
const allowQueryString='instantAllowQueryString' in document.body.dataset
if(isSupported){prefetcher.rel='prefetch'
document.head.appendChild(prefetcher)
const eventListenersOptions={capture:!0,passive:!0,}
document.addEventListener('touchstart',touchstartListener,eventListenersOptions)
document.addEventListener('mouseover',mouseoverListener,eventListenersOptions)}
function touchstartListener(event){lastTouchTimestamp=performance.now()
const linkElement=event.target.closest('a')
if(!linkElement){return}
if(!isPreloadable(linkElement)){return}
linkElement.addEventListener('touchcancel',touchendAndTouchcancelListener,{passive:!0})
linkElement.addEventListener('touchend',touchendAndTouchcancelListener,{passive:!0})
urlToPreload=linkElement.href
preload(linkElement.href)}
function touchendAndTouchcancelListener(){urlToPreload=undefined
stopPreloading()}
function mouseoverListener(event){if(performance.now()-lastTouchTimestamp<1100){return}
const linkElement=event.target.closest('a')
if(!linkElement){return}
if(!isPreloadable(linkElement)){return}
linkElement.addEventListener('mouseout',mouseoutListener,{passive:!0})
urlToPreload=linkElement.href
mouseoverTimer=setTimeout(()=>{preload(linkElement.href)
mouseoverTimer=undefined},65)}
function mouseoutListener(event){if(event.relatedTarget&&event.target.closest('a')==event.relatedTarget.closest('a')){return}
if(mouseoverTimer){clearTimeout(mouseoverTimer)
mouseoverTimer=undefined}else{urlToPreload=undefined
stopPreloading()}}
function isPreloadable(linkElement){if(urlToPreload==linkElement.href){return}
const urlObject=new URL(linkElement.href)
if(urlObject.origin!=location.origin){return}
if(!allowQueryString&&urlObject.search&&!('instant' in linkElement.dataset)){return}
if(urlObject.hash&&urlObject.pathname+urlObject.search==location.pathname+location.search){return}
if('noInstant' in linkElement.dataset){return}
return!0}
function preload(url){prefetcher.href=url}
function stopPreloading(){prefetcher.removeAttribute('href')}